import { render, staticRenderFns } from "./LeadPayments.vue?vue&type=template&id=f9f53ed6&scoped=true"
import script from "./LeadPayments.vue?vue&type=script&lang=ts"
export * from "./LeadPayments.vue?vue&type=script&lang=ts"
import style0 from "./LeadPayments.vue?vue&type=style&index=0&id=f9f53ed6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f53ed6",
  null
  
)

export default component.exports